export default "__VITE_ASSET__CW_9wAOe__"